import { setBlockTracking as _setBlockTracking, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/minimap-europe.png'
import _imports_1 from '@/assets/images/minimap-europe@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-75c560aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_1 + ' 2x'
const _hoisted_2 = { class: "absolute top-0 left-0 max-w-min text-desktop-cap text-accent" }
const _hoisted_3 = { class: "Minimap flex-none relative flex justify-center items-center text-white" }
const _hoisted_4 = { class: "relative flex-none" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  srcset: _hoisted_1,
  alt: "",
  width: "236",
  height: "237"
}, null, -1))
const _hoisted_6 = { class: "Icon absolute flex justify-center items-center size-0 text-black" }
const _hoisted_7 = { class: "Label Label--germany absolute font-screamer font-bold leading-screamer uppercase" }
const _hoisted_8 = { class: "Label Label--austria absolute font-screamer font-bold leading-screamer uppercase" }

export function render(_ctx, _cache) {
  const _component_UIIcon = _resolveComponent("UIIcon")

  return _cache[0] || (
    _setBlockTracking(-1),
    _cache[0] = _createElementVNode("div", { class: "StoryMinimap relative flex" }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("map.minimap.title")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_UIIcon, {
              class: "flex-none text-32",
              name: "symbol"
            })
          ]),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("map.minimap.germany")), 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("map.minimap.austria")), 1)
        ]),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n, i) => {
          return _createElementVNode("span", {
            key: "n",
            class: _normalizeClass(["Cross absolute flex justify-center items-center size-8 text-accent", ['top-0', 'right-0', 'bottom-0', 'left-0'][i]])
          }, null, 2)
        }), 64))
      ])
    ]),
    _setBlockTracking(1),
    _cache[0]
  )
}